import React, { Fragment } from 'react';
import { userData } from '../../data';
import Footer from '../Layout/Footer/Footer';
import Header from '../Layout/Header/Header';
// import './PrivacyPolicy.css'

const PrivacyPolicy = () => {
    return (
        <Fragment>
           
                <section>
                <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
                <h1>Privacy Policy</h1>
                <p>
                  This Website and related app/apps are run by{" "}
                  <a href="https://trustitworld.com.bd/" target="_blank" rel="noopener noreferrer">
                    https://trustitworld.com.bd/
                  </a>
                  . Trust IT Patient app, Trust IT Doctors app, Trust IT Report app, Anaesmon is a
                  brand name of Trust IT Solutions Corp. (henceforth referred to as Trust IT), a
                  company registered in Canada with company registration number BC1045871
                  with registered offices at 8505 Wildwood Pl, Surrey, BC, Canada V4N5C5.
                </p>
          
                <h2>Scope of Policy</h2>
                <p>
                  This policy (together with our terms of use as set out at{" "}
                  <a
                    href="https://trustitworld.com.bd/terms-and-condition"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    https://trustitworld.com.bd/terms-and-condition
                  </a>
                  ) applies to your use of the PATIENT website (and all related services
                  and features, collectively, the “Website/app/apps”).
                </p>
                <p>
                  This policy sets out the basis on which any personal data we collect
                  from you, or that you provide to us, will be processed by us. Please
                  read the following carefully to understand our views and practices
                  regarding your personal data and how we will treat it.
                </p>
                <p>
                  By registering with, or using, the Website/app/apps, you consent to the
                  collection, use, and transfer of that data and your information under
                  the terms of this Privacy Policy.
                </p>
          
                <h2>Information We May Collect From You</h2>
                <ul>
                  <li>
                    <strong>Submitted Information:</strong> Information you provide when
                    filling out forms, corresponding with us, or provided by healthcare
                    personnel for your medical management. This includes, but is not
                    limited to, your name, nickname, age, postcode, email address, and
                    medical information.
                  </li>
                  <li>
                    <strong>Anonymous Information:</strong> Technical details (device
                    type, operating system, browser type, etc.) and log information about
                    resources accessed.
                  </li>
                  <li>
                    <strong>Correspondence:</strong> Records of communication if you
                    contact us.
                  </li>
                </ul>
          
                <h2>Cookies</h2>
                <p>
                  We use cookies to distinguish you from other users of the Website/app/apps.
                  For detailed information, see our{" "}
                  <a
                    href="https://trustitworld.com.bd/cookies"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    cookie policy
                  </a>
                  .
                </p>
          
                <h2>Uses Made of the Information</h2>
                <ul>
                  <li>
                    <strong>Submitted Information:</strong> To manage your account and
                    for internal administrative purposes.
                  </li>
                  <li>
                    <strong>Device Information:</strong> To ensure the Website displays
                    correctly on your device.
                  </li>
                  <li>
                    <strong>Log Information:</strong> To monitor visitor behavior
                    anonymously and improve the service.
                  </li>
                </ul>
          
                <h2>Disclosure of Your Information</h2>
                <p>
                  We will not provide your Submitted Information to any third party for
                  commercial purposes. We may disclose your information to enforce the
                  Terms of Use, protect rights or safety, or comply with legal
                  obligations.
                </p>
          
                <h2>How and Where We Store Your Data</h2>
                <p>
                  Data is processed in accordance with applicable laws. Third-party
                  service providers used for running the Website must meet strict security
                  standards. Transmission of data over the internet is at your own risk.
                </p>
          
                <h2>Your Rights</h2>
                <p>
                  You can control how your data is processed by managing your preferences
                  on the Website/app/apps. For access, deletion, or correction requests,
                  contact us via the provided forms.
                </p>
          
                <h2>Changes to Privacy Policy</h2>
                <p>
                  We may update this privacy policy from time to time. Changes will be
                  posted on this page.
                </p>
          
                <p>Last updated: 10th June 2016</p>
              </div>
               
                </section>
            
        </Fragment>
    );
};

export default PrivacyPolicy;